// src/lib/kinema/core/commands/commands.ts
import { createCommand } from './createCommand';
import type { Keyframe, EasingMode } from '../types';

// ─── Layer Commands ───────────────────────────────────────
export const ADD_LAYER = createCommand<{
  type: string;
  name?: string;
  parentId?: string;
  [key: string]: any;
}>('ADD_LAYER');

export const REMOVE_LAYER = createCommand<{
  layerId: string;
}>('REMOVE_LAYER');

export const UPDATE_PROPERTY = createCommand<{
  layerId: string;
  property: string;
  value: any;
}>('UPDATE_PROPERTY');

export const MOVE_LAYER = createCommand<{
  layerId: string;
  newParentId: string | null;
  newOrder: number;
}>('MOVE_LAYER');

// ─── Selection Commands ───────────────────────────────────
export const SELECT_LAYER = createCommand<{
  layerId: string | null;
  addToSelection?: boolean;
}>('SELECT_LAYER');

// ─── Playback Commands ────────────────────────────────────
export const SET_PLAYHEAD = createCommand<{
  time: number;
}>('SET_PLAYHEAD');

// ─── Effect Commands ──────────────────────────────────────
export const ADD_EFFECT = createCommand<{
  layerId: string;
  property: string;
  keyframes: Keyframe<any>[];
  id?: string;        // optional — pass to restore exact ID on undo
  enabled?: boolean;   // optional — defaults to true
}>('ADD_EFFECT');

export const ADD_KEYFRAME = createCommand<{
  layerId: string;
  property: string;
  keyframe: Keyframe<any>;
}>('ADD_KEYFRAME');

export const UPDATE_KEYFRAME = createCommand<{
  layerId: string;
  property: string;
  time: number;
  value?: any;
  easing?: EasingMode;
}>('UPDATE_KEYFRAME');

export const REMOVE_KEYFRAME = createCommand<{
  layerId: string;
  property: string;
  time: number;
}>('REMOVE_KEYFRAME');

export const REMOVE_EFFECT = createCommand<{
  layerId: string;
  property: string;
}>('REMOVE_EFFECT');

export const TOGGLE_EFFECT = createCommand<{
  layerId: string;
  property: string;
  enabled: boolean;
}>('TOGGLE_EFFECT');
